module.exports = __webpack_public_path__ + "img/glovo.ac43b3db.png";